import { configureStore } from "@reduxjs/toolkit";
import tokenReducer from "./auth";
// test
export default configureStore({
  reducer: {
    authToken: tokenReducer,
  },
});
